module.exports = __webpack_public_path__ + "img/dashiji-2022.64618c2f.jpg";